const FRONT_END_ERRORS = {
  TIME_TRACKING_DURATION_ERROR: 'TIME_TRACKING_DURATION_ERROR',
  UPDATE_DEVICE_EVENT_ERROR: 'UPDATE_DEVICE_EVENT_ERROR',
  NO_CHANGE_ARTIFACT_THUMBNAIL_DETECTED: 'NO_CHANGE_ARTIFACT_THUMBNAIL_DETECTED',
  NO_API_CALLING: 'NO_API_CALLING',
  TIMEOUT_NOT_TRIGGERED_ERROR: 'TIMEOUT_NOT_TRIGGERED_ERROR',
  INDEXEDDB_ERROR: 'INDEXEDDB_ERROR',
  API_RATE_LIMIT: 'API_RATE_LIMIT',
  SOCKET_RATE_LIMIT: 'SOCKET_RATE_LIMIT',
  SOCKET_ACK_TIMEOUT: 'SOCKET_ACK_TIMEOUT',
  SOCKET_ACK_ERROR: 'SOCKET_ACK_ERROR',
};

const FRONT_END_ERRORS_EMITTER_CONSTANTS = {
  API_SPAM_TRACKING: 'API_SPAM_TRACKING',
  SOCKET_SPAM_TRACKING: 'SOCKET_SPAM_TRACKING',
};

export { FRONT_END_ERRORS, FRONT_END_ERRORS_EMITTER_CONSTANTS };
